import React, { Component } from 'react';
import ReactDiffViewer from 'react-diff-viewer';
import { Button, Label } from 'semantic-ui-react';
import Select from 'react-select';

const formatValue = (value) => {
  if (value) {
    // Here we are using the flag provide by the ruby to identify the references and the key of each property
    value = value
      .replace('"{{', '<strong>{</strong>ref: <strong>')
      .replace('}}"', '}</strong>')
      .replace('{{', '<strong>{</strong>ref: <strong>')
      .replace('}}', '}</strong>')
      .replace('"{key-start}', '<span class="property-block"></span><strong>')
      .replace('{key-end}"', '</strong>');
  } else {
    value = '';
  }

  return value;
};

const highlightSyntax = (str) => (
  <pre
    dangerouslySetInnerHTML={{
      __html: `<span><Icon name='remove' />${formatValue(str)}<span>`,
    }}
    style={{ display: 'inline' }}
  />
);

export default class CompareDiff extends Component {
  constructor(props) {
    super(props);
    this.compRef = React.createRef();
    this.method = { value: 'diffLines', label: 'Lines' };
    this.handleReviewed = this.handleReviewComplete.bind(this);
    this.setMethod = (element) => {
      this.method = element;
    };

    this.state = {
      selectedFile: { value: 'diffLines', label: 'Lines' },
      initialPosition: 0,
      blocks: [],
      review: 0,
      reviewed: false,
    };

    // get the previous review block and remove the style from the unselected one
    this.previousReview = () => {
      this.handleStateChange(this.state.review - 1, 'review');
      const unselected = this.state.blocks[this.state.review - 1];
      const selected = this.state.blocks[this.state.review - 2];

      // scroll to the selected block or back to the top if there is no block selected
      if (selected) {
        this.scrollableTarget.animate(
          {
            scrollTop: selected.position - 10,
          },
          800,
        );
      } else {
        $('#impact-table').removeClass('review-changes');
        this.scrollableTarget.animate(
          {
            scrollTop: 0,
          },
          800,
        );
      }

      // add style to the previous block and removing from the next one
      if (unselected) {
        this.clearBlocksReviewStyle(unselected);
      }
      if (selected) {
        this.addReviewStyleToBlock(selected);
      }
    };

    // get the next review block and remove the style from the previous one
    this.nextReview = () => {
      this.handleStateChange(this.state.review + 1, 'review');
      const unselected = this.state.blocks[this.state.review - 1];
      const selected = this.state.blocks[this.state.review];

      // check and enable the save button if the review is the last one
      if (this.state.review + 1 == this.state.blocks.length) {
        this.handleStateChange(true, 'reviewed');
        this.handleReviewed();
      }
      // scroll to the selected block
      this.scrollableTarget.animate(
        {
          scrollTop: selected.position - 15,
        },
        800,
      );

      // add style to the selected block and removing from the previous one
      $('#impact-table').addClass('review-changes');
      if (unselected) {
        this.clearBlocksReviewStyle(unselected);
      }
      if (selected) {
        this.addReviewStyleToBlock(selected);
      }
    };
  }

  handleReviewComplete() {
    // eslint-disable-next-line no-prototype-builtins
    if (this.props.hasOwnProperty('reviewedHandler')) {
      return this.props.reviewedHandler();
    }
  }

  // Remove the review style from the block
  clearBlocksReviewStyle(unselected) {
    unselected.block.forEach((line, idx, array) => {
      line.classList.remove('diff-changed-block');
      if (idx === 0) {
        line.classList.remove('diff-changed-block-first');
      }

      if (idx === array.length - 1) {
        line.classList.remove('diff-changed-block-last');
      }
    });
  }

  // Add review style to the block
  addReviewStyleToBlock(selected) {
    selected.block.forEach((line, idx, array) => {
      line.classList.add('diff-changed-block');
      if (idx === 0) {
        line.classList.add('diff-changed-block-first');
      }

      if (idx === array.length - 1) {
        line.classList.add('diff-changed-block-last');
      }
    });
  }

  // identify the properties blocks for all changes
  componentDidMount() {
    const lines = document.querySelectorAll('tr');
    this.scrollableTarget = $('#scrollable-content');
    // this const is used to get the right position of each property block changed
    const initialPosition = this.scrollableTarget.offset().top;
    const propertiesBlocks = [];

    // to get each block we need to check all lines and group using the property-block class, that is the flag to identify the begin of each property
    lines.forEach((e) => {
      let last = propertiesBlocks[propertiesBlocks.length - 1];

      if (e.querySelectorAll('.property-block').length > 0) {
        propertiesBlocks.push({
          changed: false,
          block: [e],
          position: $(e).offset().top - initialPosition,
        });
        last = propertiesBlocks[propertiesBlocks.length - 1];
      } else if (last) {
        last.block.push(e);
      }

      // identify changed properties
      if (
        (e.querySelectorAll("[class$='added']").length > 0 ||
          e.querySelectorAll("[class$='removed']").length > 0) &&
        last
      ) {
        last.changed = true;
      }
    });

    // saving the changed block in the state
    this.handleStateChange(
      propertiesBlocks.filter((block) => block.changed),
      'blocks',
    );
  }

  handleStateChange(e, attribute) {
    this.setState({ [attribute]: e });
  }

  render() {
    const { selectedFile, blocks, review } = this.state;
    const options = [
      { value: 'diffChars', label: 'Chars' },
      { value: 'diffWords', label: 'Words' },
      { value: 'diffLines', label: 'Lines' },
    ];
    const newStyles = {
      variables: {
        light: {
          codeFoldGutterBackground: '#F0F0F0',
          codeFoldBackground: '#E2E4E5',
        },
      },
      line: {
        padding: '10px 2px',
        '&:hover': {
          background: '#e7f0f8',
        },
      },
    };

    return (
      <div className='DiffComponent'>
        <div className='header'>
          <div className='ui input'>
            <Label>Compare Method</Label>
            <Select
              backspaceRemovesValue={false}
              clearable={false}
              options={options}
              value={selectedFile}
              onChange={(e) => this.handleStateChange(e, 'selectedFile')}
            />
          </div>
          <div className='ui header'>
            <Button
              className='left floated navigator'
              content='Prev'
              disabled={review <= 0}
              id='previous'
              onClick={this.previousReview}
            />
            <h3 className='ui subtitle'>
              <span id='reviewed'>{review}</span> of{' '}
              <span id='total'>{blocks.length}</span> changes
            </h3>
            <Button
              className='right floated navigator'
              content='Next'
              disabled={review == blocks.length}
              id='next'
              onClick={this.nextReview}
            />
          </div>
          <div className='action-block' />
        </div>
        <div
          className='scrollable-content compressed'
          id='scrollable-content'
        >
          <ReactDiffViewer
            ref={this.compRef}
            compareMethod={`${selectedFile.value}`}
            disableWordDiff={false}
            hideLineNumbers={false}
            newValue={this.props.proposed}
            oldValue={this.props.current}
            renderContent={highlightSyntax}
            showDiffOnly={false}
            splitView={true}
            styles={newStyles}
          />
        </div>
      </div>
    );
  }
}
